import { GIFT_REGISTRY_WIDGET_NAMES } from "@/constants/widget-names";
import { RegistryFormModalWidgetDefinition } from "@apps/gift_registry/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";

import { ModalManager } from "@components/Modal/ModalManager";
import { LoggerInterface } from "@interfaces/LoggerInterface";

class RegistryFormModalWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly modalManager: ModalManager,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector
    ) {}

    start(): void {
        this.logger.debug("RegistryFormModalWidgetInjector start", {
            placholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger?.debug(
                "RegistryFormModalWidgetInjector found placeholder",
                {
                    placeholder,
                }
            );

            const widgetName =
                GIFT_REGISTRY_WIDGET_NAMES.REGISTRY_FORM_MODAL_WIDGET;

            void (async () => {
                const RegistryFormModalWidget =
                    await this.dynamicImportManager.importDefault(
                        RegistryFormModalWidgetDefinition
                    );

                const widget = new RegistryFormModalWidget(
                    {
                        target: placeholder,
                    },
                    this.logger,
                    this.modalManager
                );

                await widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RegistryFormModalWidgetInjector;
